import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { getPropertyTypesWithMixedUseForFilters } from '@/bundles/GroupFilters/consts';
import i18n from '@/bundles/Localization';
import { LocalizationEnum } from '@/bundles/Localization/enum/LocalizationEnum';
import { getProjectTransactionTypes } from '@/bundles/Projects/consts/getProjectTransactionTypes';
import { getShowArchiveFilterConfig } from '@/bundles/GroupFilters/helpers/filtersConfig/getShowArchiveFilterConfig';
import { getStaticSetFilterConfig } from '@/bundles/GroupFilters/helpers/filtersConfig/getStaticSetFilterConfig';

export const getProjectFilters = (): IFilterConfigItem[] => {
  const propertyTypesWithMixedUse = getPropertyTypesWithMixedUseForFilters();

  return [
    {
      title: i18n.t(LocalizationEnum.project_property_type) as string,
      items: propertyTypesWithMixedUse,
      name: 'project_building_type',
      type: FilterTypeEnum.autocomplete_multiple_select,
      category: FilterCategoryEnum.presentation_details,
    },
    {
      title: i18n.t(LocalizationEnum.project_transaction_category) as string,
      items: getProjectTransactionTypes(),
      name: 'project_transaction_type',
      type: FilterTypeEnum.autocomplete_multiple_select,
      category: FilterCategoryEnum.presentation_details,
    },
    // FilterCategoryEnum.created_edited start
    {
      title: 'Created/Edited Date',
      name: 'project_view_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created Date',
      name: 'project_created_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Edited Date',
      name: 'project_edited_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created/Edited by',
      name: 'project_view',
      type: FilterTypeEnum.create_updated_by_select,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created by',
      name: 'project_created_by',
      type: FilterTypeEnum.create_updated_by_select,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Edited by',
      name: 'project_edited_by',
      type: FilterTypeEnum.create_updated_by_select,
      category: FilterCategoryEnum.created_edited,
    },
    // FilterCategoryEnum.created_edited end
    getShowArchiveFilterConfig(),
    getStaticSetFilterConfig('project'),
  ].filter(Boolean) as IFilterConfigItem[];
};
